import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import useCasinoRoutes from '~/components/router/use-casino-routes';

const useCasinoLocation = () => {
	const { pathname } = useLocation();
	const {
		ROUTE_LIVE_CASINO,
		ROUTE_CASINO,
		ROUTE_CASINO_SUBMENU,
		ROUTE_CASINO_EXPLORE,
		ROUTE_LIVE_CASINO_EXPLORE,
		ROUTE_LIVE_CASINO_SUBMENU,
		ROUTE_CASINO_MY_GAMES,
		ROUTE_LIVE_CASINO_MY_GAMES
	} = useCasinoRoutes();

	const isCasinoLocation = useMemo(() => {
		return pathname.includes(ROUTE_CASINO);
	}, [ROUTE_CASINO, pathname]);

	const isLiveCasinoLocation = useMemo(() => {
		return pathname.includes(ROUTE_LIVE_CASINO);
	}, [ROUTE_LIVE_CASINO, pathname]);

	const isCasinoExploreLocation = useMemo(() => {
		return pathname.includes(ROUTE_CASINO_EXPLORE);
	}, [ROUTE_CASINO_EXPLORE, pathname]);

	const isLiveCasinoExploreLocation = useMemo(() => {
		return pathname.includes(ROUTE_LIVE_CASINO_EXPLORE);
	}, [ROUTE_LIVE_CASINO_EXPLORE, pathname]);

	const isSubmenuLocation = useMemo(() => {
		return pathname.includes(ROUTE_CASINO_SUBMENU) || pathname.includes(ROUTE_LIVE_CASINO_SUBMENU);
	}, [ROUTE_CASINO_SUBMENU, ROUTE_LIVE_CASINO_SUBMENU, pathname]);

	const isMyGamesLocation = useMemo(() => {
		return pathname.includes(ROUTE_CASINO_MY_GAMES) || pathname.includes(ROUTE_LIVE_CASINO_MY_GAMES);
	}, [ROUTE_CASINO_MY_GAMES, ROUTE_LIVE_CASINO_MY_GAMES, pathname]);

	return {
		isCasinoLocation,
		isLiveCasinoLocation,
		isCasinoExploreLocation,
		isLiveCasinoExploreLocation,
		isSubmenuLocation,
		isMyGamesLocation
	};
};

export default useCasinoLocation;
